import React from "react";
import { Link, RouteComponentProps } from "@reach/router"
import {
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Button,
  CircularProgress,
  Toolbar,
  Stack,
  Box,
} from '@material-ui/core';



import { StringParam, useQueryParams } from "use-query-params";

import { actions } from '../../services/users';



import AppPage from "../../components/AppFrame/AppPage";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { RootState } from "../../store";
import { ProfileAvatar } from "../../components/UserPhoto/UserPhoto";
import timeAgo from "../../utils/timeAgo";
import { useState } from "react";
import { orderBy } from "lodash";
import { User } from "../../types";
import UserFilters from "./UserFilters";
import RequireRole from "../../components/RequireRole";
import { AdminRole } from "../../types/auth";
import LoadingButton from "@material-ui/lab/LoadingButton";
import UserActions from "../UserDetails/UserActions";


const UsersPage: React.FC<RouteComponentProps> = () => {

  const dispatch = useDispatch();
  const state = useSelector((state: RootState) => state.users);

  const [ list, setList ] = useState<User[]>([]);

  const [ filters ] = useQueryParams({
    gender: StringParam,
    status: StringParam,
    sortBy: StringParam,
  });

  useEffect(() => {
    dispatch(actions.loadList({
      gender: filters.gender as any,
      status: filters.status as any,
      sortBy: filters.sortBy as any,
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ filters ]);


  const loadMore = () => {
    dispatch(actions.loadList({
      gender: filters.gender as any,
      status: filters.status as any,
      sortBy: filters.sortBy as any,
      loadMore: true
    }));
  }


  useEffect(() => {
    const sortByField = filters.sortBy ?? 'createTime';
    setList(
      orderBy(state.users, sortByField, 'desc')
    )
  }, [ state.users, filters.sortBy ]);


  const loading = state.listLoading && Object.keys(state.users).length === 0;
  const loadingMore = state.listLoading && Object.keys(state.users).length > 0;




  return (
    <AppPage title="Users">
      <Paper variant="outlined" sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
        <Toolbar sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            sx={{ width: '100%', padding: '10px 0px' }}
          >

            {/* <UserActions selected={selected} /> */}
            <UserFilters />


          </Stack>
        </Toolbar>

        {/* <div style={{border: '1px solid #000', flex: 1,}}>

        </div> */}

        {/* <VirtualTable
          height={800}
          width="100%"
          itemCount={Object.keys(state.users).length}
          itemSize={133}
          itemData={Object.values(state.users)}
          header={
            <TableHead>
              <TableRow>
                <TableCell align="center" sx={{ width: 120 }}>Avatar</TableCell>
                <TableCell sx={{ width: 300 }}>Name</TableCell>
                <TableCell sx={{ width: 100 }}>Age</TableCell>
                <TableCell sx={{ width: 100 }}>Status</TableCell>
                <TableCell sx={{ width: 150 }}>Registered</TableCell>
                <TableCell sx={{ width: 150 }}>Last Active</TableCell>
                <TableCell sx={{ width: 100 }}>Photos</TableCell>
                <TableCell sx={{ width: 100 }}>Chats</TableCell>
                <TableCell>ID</TableCell>
                <TableCell sx={{ width: 100 }}></TableCell>
              </TableRow>
            </TableHead>
          }
          row={UserRowMemo}
        /> */}

        {/* <UserList
          users={list}
          loading={loading}
          loadingMore={loadingMore}
          onLoadMore={loadMore}
        /> */}

        <TableContainer>
          <Table sx={{ minWidth: 650 }}>
            <TableHead>
              <TableRow>
                <TableCell align="center" sx={{ width: 120 }}>Avatar</TableCell>
                <TableCell>Name</TableCell>
                <TableCell>Age</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Registered</TableCell>
                <TableCell>Last Active</TableCell>
                <TableCell>Photos</TableCell>
                <TableCell>Chats</TableCell>
                <TableCell>ID</TableCell>
                <TableCell sx={{ width: 100 }}></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {
                list.map((user) => {
                  return (
                    <TableRow
                      key={user.id}
                      sx={{ '&:last-child td, &:last-child th': { border: 0 }, }}
                    >
                      <TableCell>
                        <ProfileAvatar userId={user.id} size={100} />
                      </TableCell>
                      <TableCell>
                        <Button component={Link} to={`/users/${user.id}`}>
                          {`${user.firstName} ${user.lastName}`}
                        </Button>
                      </TableCell>
                      <TableCell>{user.age}</TableCell>
                      <TableCell>{user.status}</TableCell>
                      <TableCell>{timeAgo(user.createTime.toDate())}</TableCell>
                      <TableCell>{timeAgo(user.lastActiveTime?.toDate())}</TableCell>
                      <TableCell>{Object.keys(user.photos || {}).length}</TableCell>
                      <TableCell>{user.chatStats?.total}</TableCell>
                      <TableCell>{user.id}</TableCell>
                      <TableCell>
                        <RequireRole role={AdminRole.manage_users}>
                          <UserActions user={user} />
                        </RequireRole>
                      </TableCell>
                    </TableRow>
                  );
                })
              }
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
      <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: 2 }}>
        {
          loading ? <CircularProgress /> : null
        }

        {
          !loading ? <LoadingButton loading={loadingMore} onClick={loadMore}>Load more</LoadingButton> : null
        }

      </Box>
    </AppPage>
  );
};

export default UsersPage;